import React from 'react';
import { cn } from '@/lib/utils';

function Container({className, children}: {className?: string, children: React.ReactNode}) {
  return (
    <div className={cn("px-6", className)}>
      {children}
    </div>
  );
}

export default Container;